import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchShippingMethods, fetchShippingMethod } from './request';
import {
  createShippingMethod,
  updateShippingMethod,
  deleteShippingMethod,
} from '@/api/mutations';
import { SHIPPING_METHODS_QUERY_KEY, SHIPPING_METHOD_QUERY_KEY } from './key';
import toast from 'react-hot-toast';

export const useShippingMethods = () => {
  return useQuery({
    queryKey: [SHIPPING_METHODS_QUERY_KEY],
    queryFn: fetchShippingMethods,
  });
};

export const useShippingMethod = (id?: number) => {
  return useQuery({
    queryKey: [SHIPPING_METHOD_QUERY_KEY, id],
    queryFn: () => fetchShippingMethod(id!),
    enabled: !!id,
  });
};

export const useCreateShippingMethod = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createShippingMethod,
    onSuccess: ({ response }) => {
      toast.success(response);
      queryClient.invalidateQueries({ queryKey: [SHIPPING_METHODS_QUERY_KEY] });
      onSuccess?.();
    },
  });
};

export const useUpdateShippingMethod = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateShippingMethod,
    onSuccess: ({ response }) => {
      toast.success(response);
      queryClient.invalidateQueries({ queryKey: [SHIPPING_METHODS_QUERY_KEY] });
      onSuccess?.();
    },
  });
};

export const useDeleteShippingMethod = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteShippingMethod,
    onSuccess: ({ response }) => {
      toast.success(response);
      queryClient.invalidateQueries({ queryKey: [SHIPPING_METHODS_QUERY_KEY] });
      onSuccess?.();
    },
  });
};
